export enum DropAlignment {
    'SPACE_BETWEEN' = 0,
    'TOP' = 1,
    'BOTTOM' = 2,
}